import React from 'react';
import { useTranslation } from 'react-i18next';

import { useUpdateRestaurantDigitalCertificate } from '@/api/hooks/useCertificate';
import { DigitalCertificate, RestaurantResponse } from '@/api/lib/restaurant';

import { WriteSwornDeclarationForm } from '../WriteSwornDeclarationForm';
import { Typography } from '@/components/atoms/Typography';
import { Form } from '@/components/forms/core/Form';
import { Button } from '@/components/molecules/Button';

export interface UpdateDigitalCertificateFormProps {
  restaurant: RestaurantResponse;
}

export const UpdateDigitalCertificateForm = ({ restaurant }: UpdateDigitalCertificateFormProps) => {
  const { t } = useTranslation();
  const { isLoading: isAddingRestaurant, mutateAsync: updateRestaurantMutation, isError: isAddingError } = useUpdateRestaurantDigitalCertificate(restaurant.id);

  const handleSubmit = async (data: DigitalCertificate) => {
    await updateRestaurantMutation({
      ...data
    });
  };

  return (
    <Form
      data-testid="restaurant-form"
      onSubmit={handleSubmit}
      onlyTouchedFields={false}
      defaultValues={{
        company: restaurant?.digitalCertificate?.company || '',
        firstName: restaurant?.digitalCertificate?.firstName || '',
        lastName: restaurant?.digitalCertificate?.lastName || '',
        date: restaurant?.digitalCertificate?.date || '',
        restaurantName: restaurant?.digitalCertificate?.address || restaurant.formattedAddress,
        suppliers: restaurant?.digitalCertificate?.suppliers || [''],
        address: restaurant?.digitalCertificate?.restaurantName || restaurant.name
      }}
      className="flex flex-col gap-5"
      render={({ watch }) => {
        return (
          <>
            <WriteSwornDeclarationForm watch={watch} showRestaurantNameAddress={false}>
              <div className="flex items-center gap-1 mt-5 mb-3">
                <input type="checkbox" id="acceptTerms" className="mr-2 rounded" required />
                <Typography variant="extraSmall" color="gray">
                  {t('swornDeclaration.acceptTerms')}
                </Typography>
              </div>
              <Button
                type="submit"
                fullWidth
                color="primary"
                label={restaurant?.digitalCertificate ? 'Modifier le certificat' : 'Ajouter le certificat'}
                loading={isAddingError || isAddingRestaurant}
              />
            </WriteSwornDeclarationForm>
          </>
        );
      }}
    />
  );
};
